import { render, staticRenderFns } from "./warehouseModal.vue?vue&type=template&id=fa67f830"
import script from "./warehouseModal.vue?vue&type=script&lang=js"
export * from "./warehouseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports